<template>
  <div>
    <div class="toolbar">
      <el-input v-model="keyword" clearable placeholder="收货单号" style="width:200px" @keyup.enter.native="load" />
      <el-select v-model="projectId" clearable filterable placeholder="项目" style="width:200px" @change="load">
        <el-option v-for="p in projects" :key="p.id" :label="projectLabel(p)" :value="p.id" />
      </el-select>
      <el-select v-model="supplierId" clearable filterable placeholder="供应商" style="width:180px" @change="load">
        <el-option v-for="s in suppliers" :key="s.id" :label="s.name" :value="s.id" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
    </div>

    <el-table :data="pageList" border v-loading="loading">
      <el-table-column prop="receiveNo" label="收货单号" width="160" />
      <el-table-column prop="reqNo" label="申请单号" width="160" />
      <el-table-column prop="projectName" label="项目" min-width="140">
        <template slot-scope="{ row }">
          <project-name-link :project-id="row.projectId" :name="row.projectName" />
        </template>
      </el-table-column>
      <el-table-column prop="supplierName" label="供应商" min-width="130" />
      <el-table-column prop="createdByName" label="收货人" width="80" />
      <el-table-column prop="createdAt" label="收货时间" width="90">
        <template slot-scope="{ row }">{{ formatDateOnly(row.createdAt) }}</template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip />
      <el-table-column label="操作" width="100" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openDetail(row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="listTotal"
      :page="page"
      :page-size="pageSize"
      @current-change="onPageChange"
      @size-change="onPageSizeChange"
    />


    <el-drawer title="收货单详情" :visible.sync="detailVisible" size="560px">
      <div style="padding:0 16px 16px" v-if="detail">
        <p>收货单号：{{ detail.receive.receiveNo }}</p>
        <p>申请单号：{{ detail.receive.reqNo || '-' }}</p>
        <p>项目：{{ detail.receive.projectName }} · 供应商：{{ detail.receive.supplierName }}</p>
        <p>收货人：{{ detail.receive.createdByName || '-' }} · {{ detail.receive.createdAt }}</p>
        <p v-if="detail.receive.remark">备注：{{ detail.receive.remark }}</p>
        <el-table :data="detail.lines" border size="small" style="margin-top:12px">
          <el-table-column prop="materialName" label="材料" min-width="140" />
          <el-table-column prop="unit" label="单位" width="70" />
          <el-table-column prop="reqQty" label="申请数量" width="90" />
          <el-table-column prop="alreadyQty" label="此前已收" width="90" />
          <el-table-column prop="receiveQty" label="本次收货" width="90" />
          <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip>
            <template slot-scope="{ row }">{{ row.remark || '-' }}</template>
          </el-table-column>
        </el-table>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { listMaterialReceives, getMaterialReceive, listSuppliers } from '../../api/supply'
import { listProjects } from '../../api/project'
import ListPagination from '../../components/ListPagination.vue'
import ProjectNameLink from '../../components/ProjectNameLink.vue'
import listPaging from '../../mixins/listPaging'

export default {
  name: 'MaterialReceive',
  components: { ListPagination, ProjectNameLink },
  mixins: [listPaging],
  data() {
    return {
      keyword: '', projectId: null, supplierId: null,
      projects: [], suppliers: [],
      list: [], loading: false,
      detailVisible: false, detail: null
    }
  },
  created() {
    this.loadMeta()
    const pid = Number(this.$route.query.projectId)
    if (pid) this.projectId = pid
    this.load()
  },
  methods: {
    formatDateOnly(v) {
      if (!v) return '-'
      const s = String(v).replace('T', ' ')
      return s.length >= 10 ? s.slice(0, 10) : s
    },
    projectLabel(p) {
      return (p && (p.name || p.customerName)) || ''
    },
    async loadMeta() {
      const [p, s] = await Promise.all([listProjects({}), listSuppliers({})])
      this.projects = p.data || []
      this.suppliers = (s.data || []).filter(x => x.enabled !== 0)
    },
    async load() {
      this.loading = true
      try {
        const res = await listMaterialReceives({
          keyword: this.keyword || undefined,
          projectId: this.projectId || undefined,
          supplierId: this.supplierId || undefined
        })
        this.list = res.data || []
        this.page = 1
      } finally { this.loading = false }
    },
    async openDetail(row) {
      const res = await getMaterialReceive(row.id)
      this.detail = res.data
      this.detailVisible = true
    }
  }
}
</script>

<style scoped>
.toolbar { display:flex; gap:8px; margin-bottom:12px; flex-wrap:wrap; }
</style>
